export enum ProductType {
  CREDIT = 'CREDIT',
  INSURANCE = 'INSURANCE',
  INVESTMENT = 'INVESTMENT',

}
